export default __webpack_public_path__ + "static/media/t10.d706b8f2.jpg";